import { Component, OnInit } from '@angular/core';
import { APP_CONFIG } from '@core-app/app.config';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
  selector: 'coro-image-banner-color-bg',
  templateUrl: './coro-image-color.component.html',
  styleUrls: ['./coro-image-color.component.scss'],
  standalone: false,
})
export class CoroImageBannerComponent extends BlockAbstractComponent implements OnInit {
  imageUrl!: string;

  override ngOnInit(): void {
    if (this.block?.data?.image_url) {
      this.imageUrl = APP_CONFIG.frontend + this.block.data.image_url;
    }
  }
}
